<p-dialog header="Add Tracking" [(visible)]="displayTracking" [modal]="true" [responsive]="true"
    [style]="{ width: '80vw' }" (onHide)="onDialogClose()">
    <div class="p-field p-formgrid p-grid">
        <span class="p-input-icon-left" style="float: right; margin-left: 5px;">
            <i class="pi pi-search searchPosition"></i>
            <input type="text" style="float: right; margin: 2px 5px 0px 0px;" pInputText placeholder="Search..."
                [(ngModel)]="searchValue" (ngModelChange)="changed($event)" />
        </span>
        <p-table [value]="trackingData" class="w-100" [lazy]="true" [paginator]="true" [first]="first"
            [totalRecords]="totalTBRecord" [rows]="pageSize" [showCurrentPageReport]="true" dataKey="id"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="rowsPerPageTB" (onPage)="loadTrackingLazy($event)" selectionMode="multiple"
            [(selection)]="selectedTracking">
            <ng-template pTemplate="header">
                <tr>
                    <ng-container *ngFor="let field of trackingOptions">
                        <th [id]="field.code"
                            *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, field.code, productSerialSettings)">
                            {{ utilityServiceObj?.displayName(field.code, trackingOptions, 'label') }}
                            <span
                                *ngIf="utilityServiceObj?.displayName(field.code, trackingOptions, 'control') === 'Percentage'">(%)</span>
                            <span
                                *ngIf="utilityServiceObj?.displayName(field.code, trackingOptions, 'control') === 'Currency'">
                                ({{ utilityServiceObj?.displayName(field.code, trackingOptions, 'currency') }})
                            </span>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-i="rowIndex">
                <tr [pSelectableRow]="product" [pSelectableRowIndex]="rowIndex">
                    <ng-container *ngFor="let field of trackingOptions">
                        <td *ngIf="utilityServiceObj?.showTrackingOption(trackingOptions, field.code, productSerialSettings)"
                            style="word-break: break-all">

                            <ng-container
                                *ngIf="utilityServiceObj?.displayName(field.code, trackingOptions, 'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">
                                    {{ product?.[field.field] }}
                                </span>
                                <span *ngIf="controlType === 'DatePicker'">
                                    {{ product?.[field.field] && (product?.[field.field] | date: "MM/dd/yyyy") }}
                                </span>
                            </ng-container>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td class="p-text-center">No data found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="onSave()" class="p-button-label" label="Save"></button>
    </p-footer>
</p-dialog>